export default __webpack_public_path__ + "static/emptyBox-bbc7fbf69934d4e0b26a86db53834273.png";